import React, {useContext, useEffect, useState} from "react";
import {Select, Row, Col, Button} from "antd";
import {AppContext} from "../../contexts/app-context";
import GoogleAndroidAppLink from "../google-android-app-link";
import Cookies from 'js-cookie';
import {useLocation} from "react-router-dom";
import { userServices } from "../../services";
import { ACCESS_TO_ALL_DELIVERIES_ITEMS, ACCESS_TO_ANY_DELIVERIES_ITEMS } from "../../helpers/user_permission.helper";
import { consignorService } from "../../services";
import InputField from "../input-field";

import i18n from "../../i18n";

export default function SearchFilter() {
  const {Option} = Select;
  const appContext = useContext(AppContext);
  const [clearFilterFlag, setClearFilterFlag] = useState(false);
  const [isFiltered, setIsFiltered] = useState(false);

  const path = useLocation().pathname.split("/").slice(-1);
  const {regionsLoadings, regionsUnloadings} = appContext.filter;

  const [searchString, setSearchString] = useState(appContext.filter.searchString || '');

  const getCookies = (name) => {
    let value = {};
    if (Cookies.get(`${name}-${path}`)) {
      Cookies.get(`${name}-${path}`)
        .split(",")
        .map((item) => {
          const itemArr = item.split(': ')
          if (itemArr[1] !== '') {
            Object.assign(value, {[itemArr[0]]: itemArr[1].split('|').map((item) => Number(item))});
          } else {
            Object.assign(value, {[itemArr[0]]: []});
          }
        })
    }
    return value;
  }


  const [selectedSorting, setSelectedSorting] = useState(appContext.filter.selectedSorting);

  const isEmptyFilter = !searchString;


  const onChangeFilterSort = (value) => {
    setSelectedSorting(value);
  };

  const setCookies = (name, values) => {
    if (values) {
      const valuesArr = [];
      for (const [key, value] of Object.entries(values)) {
        valuesArr.push(`${key}: ${value.toString().replaceAll(',', '|')}`);
      }
      Cookies.set(`${name}-${path}`, valuesArr.join());
    } else if (Cookies.get(`${name}-${path}`)) {
      Cookies.remove(`${name}-${path}`);
    }
  }

  useEffect(() => {
    if (!isFiltered && !isEmptyFilter || clearFilterFlag) {
      appContext.applySearchString(searchString);
      if (!isFiltered && !isEmptyFilter) {
        setIsFiltered(true);
        setClearFilterFlag(true);
      }
    }
  }, [isFiltered, clearFilterFlag]);

  const applyFilterParams = () => {
    appContext.applySearchString(searchString);
    appContext.setIsNeedUpdateUnloadingList(true);

    if (!isEmptyFilter) {
      setIsFiltered(true);
      setClearFilterFlag(true);
    }
  };

  const clearFilterParams = () => {
    if (isFiltered) {
      setIsFiltered(false);
    }
  };

  function filter(inputValue, path) {
    return path.some(option => option.title.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
  }

  const sortItems = appContext.filter.sort;
  const applyGoogleAndroidAppLink = false;

  return (
    <div className="filters-container">
      <div className="container">
        <div className="filters-container__wrapper">
          <Row gutter={22} style={{padding: "0", margin: "0", rowGap: "10px"}} type="flex" justify="start">
            <Col xs={24} sm={24} md={16} lg={16} xl={16}>
              <InputField
                style={{height: '100%'}}
                name="fullName"
                title={i18n.t('constants.formFields.FullName')}
                placeholder="Поиск"
                size="large"
                value={searchString}
                setValue={
                  (value) => {setSearchString(value)}
                }
                getFieldErrors={() => {}}
              />
            </Col>
            <Col xs={12} sm={12} md={5} lg={5} xl={5} style={{}}>
              <Select
                size="default"
                onChange={(value) => {
                  onChangeFilterSort(value);
                }}
                defaultValue={selectedSorting}
                value={selectedSorting}
                style={{width: "100%", height: "100%"}}
              >
                {sortItems.map((sortItem) => {
                  return (
                    <Option key={sortItem.name} value={sortItem.name} selected={sortItem.selected}>
                      {sortItem.title}
                    </Option>
                  );
                })}
              </Select>
            </Col>
            <Col className="filters-buttons" xs={12} sm={12} md={3} lg={3} xl={3} style={{}}>
              <Button
                className="filters-button"
                type="primary"
                size="default"
                icon="search"
                htmlType="button"
                title={i18n.t('components.filter.buttons.apply')}
                onClick={applyFilterParams}
              />
              <Button
                className="filters-button filters-button--clear"
                type="primary"
                size="default"
                icon="close"
                disabled={isEmptyFilter}
                htmlType="button"
                title={i18n.t('components.filter.buttons.clear')}
                style={{border: "none", outline: "none", marginLeft: "5px"}}
                onClick={clearFilterParams}
              />
            </Col>
          </Row>
        </div>
      </div>
      {/*<YoutubeVideoLink />*/}
      {applyGoogleAndroidAppLink ? <GoogleAndroidAppLink/> : null}
    </div>
  );
}
